import { useCachedApiCall, type UseCachedApiCallResult } from '@hooks/apiCall';
import { traitsCache } from './traitStore';
import type { Trait } from '@api/DepartmentService';

/** Cache-backed traits (spesialkompetanser) of a department. */
export const useTraitsEntry = (
    departmentId?: string,
): UseCachedApiCallResult<Trait[]> =>
    useCachedApiCall(traitsCache, [departmentId]);
